// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppraisalCycle.css */


.appraisal-table-container {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;

    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    transition: all 0.3s ease;
    width: 80% !important;

    border: 1px solid #E4E4E4;
    background: var(--Colors-Base-Base-White, #FFF);
    box-shadow: 0px 100px 50px 0px rgba(0, 0, 0, 0.00), 0px 115px 46px 0px rgba(0, 0, 0, 0.01), 0px 65px 39px 0px rgba(0, 0, 0, 0.05), 0px 29px 29px 0px rgba(0, 0, 0, 0.09), 0px 7px 16px 0px rgba(0, 0, 0, 0.10);
}


.appraisal-table-header {
    background-color: #ffffff;
    border-bottom: 3px solid #dbd4d4;
}


.appraisal-table-cell {
    font-size: 14px;
    color: #333;
    padding: 12px;
    border-bottom: 1px solid #ddd;
    text-align: left;
}


.appraisal-table-heading {
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    color: #0070E9 !important;
    padding: 12px;
}


.appraisal-table-body-row:hover {
    background-color: #f9f9f9;
    cursor: pointer;
}


.expand-icon-cell {
    text-align: center;
}

.expand-icon-cell .MuiSvgIcon-root {
    color: #0072e5;
    transition: transform 0.3s ease;
}

.expand-icon-cell .MuiSvgIcon-root.open {
    transform: rotate(180deg);
}

/* Accordion styling */
.appraisal-accordion-root {
    background-color: #f0f0f0;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    margin-top: 10px;
}

.appraisal-accordion-summary {
    font-weight: bold;
    color: #0072e5;
    padding: 10px 20px;
    background-color: #fff;
}

.appraisal-accordion-details {
    padding: 20px;
    background-color: #fafafa;
    border-top: 1px solid #ddd;
    color: #555;
}

.accordion-details-content {
    font-size: 14px;
    line-height: 1.5;
}

.css-1ex1afd-MuiTableCell-root {
    font-family: "Inter" !important;
}


.buttonContainermodal {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

.saveButtonmodal {
    background-color: #FE602F !important;
    color: white !important;
}

.cancelButtonmodal {
    background-color: #FE602F !important;
    color: white;
}

.switch-active {
    color: rgb(103, 245, 103) !important;
}

.switch-inactive {
    color: grey !important;
}

.switch-active-thumb .MuiSwitch-thumb {
    background-color: rgb(120, 245, 174);
}

.switch-inactive-thumb .MuiSwitch-thumb {
    background-color: rgb(249, 124, 124);
}

.appraisalHeading {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    line-height: 21.78px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 20px;

}`, "",{"version":3,"sources":["webpack://./src/views/panel/PerformanceManagement/HRView/AppraisalCycle.css"],"names":[],"mappings":"AAAA,uBAAuB;;;AAGvB;IACI,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;;IAEhB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;;IAErB,yBAAyB;IACzB,+CAA+C;IAC/C,8MAA8M;AAClN;;;AAGA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;;AAGA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;;AAGA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;AACjB;;;AAGA;IACI,yBAAyB;IACzB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;;AAEvB","sourcesContent":["/* AppraisalCycle.css */\n\n\n.appraisal-table-container {\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    overflow: hidden;\n\n    margin-top: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 20px;\n    transition: all 0.3s ease;\n    width: 80% !important;\n\n    border: 1px solid #E4E4E4;\n    background: var(--Colors-Base-Base-White, #FFF);\n    box-shadow: 0px 100px 50px 0px rgba(0, 0, 0, 0.00), 0px 115px 46px 0px rgba(0, 0, 0, 0.01), 0px 65px 39px 0px rgba(0, 0, 0, 0.05), 0px 29px 29px 0px rgba(0, 0, 0, 0.09), 0px 7px 16px 0px rgba(0, 0, 0, 0.10);\n}\n\n\n.appraisal-table-header {\n    background-color: #ffffff;\n    border-bottom: 3px solid #dbd4d4;\n}\n\n\n.appraisal-table-cell {\n    font-size: 14px;\n    color: #333;\n    padding: 12px;\n    border-bottom: 1px solid #ddd;\n    text-align: left;\n}\n\n\n.appraisal-table-heading {\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    color: #0070E9 !important;\n    padding: 12px;\n}\n\n\n.appraisal-table-body-row:hover {\n    background-color: #f9f9f9;\n    cursor: pointer;\n}\n\n\n.expand-icon-cell {\n    text-align: center;\n}\n\n.expand-icon-cell .MuiSvgIcon-root {\n    color: #0072e5;\n    transition: transform 0.3s ease;\n}\n\n.expand-icon-cell .MuiSvgIcon-root.open {\n    transform: rotate(180deg);\n}\n\n/* Accordion styling */\n.appraisal-accordion-root {\n    background-color: #f0f0f0;\n    border-radius: 8px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    margin-top: 10px;\n}\n\n.appraisal-accordion-summary {\n    font-weight: bold;\n    color: #0072e5;\n    padding: 10px 20px;\n    background-color: #fff;\n}\n\n.appraisal-accordion-details {\n    padding: 20px;\n    background-color: #fafafa;\n    border-top: 1px solid #ddd;\n    color: #555;\n}\n\n.accordion-details-content {\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.css-1ex1afd-MuiTableCell-root {\n    font-family: \"Inter\" !important;\n}\n\n\n.buttonContainermodal {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n}\n\n.saveButtonmodal {\n    background-color: #FE602F !important;\n    color: white !important;\n}\n\n.cancelButtonmodal {\n    background-color: #FE602F !important;\n    color: white;\n}\n\n.switch-active {\n    color: rgb(103, 245, 103) !important;\n}\n\n.switch-inactive {\n    color: grey !important;\n}\n\n.switch-active-thumb .MuiSwitch-thumb {\n    background-color: rgb(120, 245, 174);\n}\n\n.switch-inactive-thumb .MuiSwitch-thumb {\n    background-color: rgb(249, 124, 124);\n}\n\n.appraisalHeading {\n    font-family: \"Inter\";\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 21.78px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n    align-items: center;\n    margin-top: 10px;\n    margin-bottom: 20px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
